/**
 * @fileoverview Module for `src/dashboard/campaign-details/VrbmFormNotice.js`.
 */

import PropTypes from 'prop-types';

/**
 * Shows additional instructions for campaigns that include voter registration forms.
 *
 * @param {Object} params
 * @returns {JSX.Element|null} Campaign notice when applicable.
 */
function VrbmFormNotice({ campaignType }) {
  if (campaignType === 'vrbm-form' || campaignType === 'vrbm-no9' || campaignType === 'vrbm-form-labs') {
    return (
      <p className='mb-2'>
        <i className='fa fa-exclamation-circle' />
        { ' ' }
        Registration Forms Enclosed. Please review <a href='/vf-instructions-vr-form.pdf'>instructions</a> carefully.
      </p>
    );
  }
  return null;
}

VrbmFormNotice.propTypes = {
  campaignType: PropTypes.string.isRequired,
};

export default VrbmFormNotice;
